import { Form, Input } from 'antd/es'
import React from 'react'

import useFormModal from '@/hooks/use-form-modal'

export interface PostPriceModalProps {
  onSetPrice: (value: number) => void
}

export default function usePostPriceModal({
  onSetPrice,
}: PostPriceModalProps) {
  const useModal = useFormModal({
    onSubmit: (values: { price: string }) => {
      onSetPrice(Number(values.price))
    },
    getFields: () => {
      return (
        <>
          <Form.Item name="price" label="Price">
            <Input type="number" min={0} />
          </Form.Item>
        </>
      )
    },
    title: 'The Price',
    submitText: 'Confirm',
    modalProps: {
      destroyOnClose: true,
    },
  })

  return useModal
}
